









































import Vue from 'vue'
import { FormatterHelper } from '../utils/FormatterHelper';
export default Vue.extend({
  name: 'CustomerSelectedInformation',
  props: {
    addressInfo: {
      type: Array,
      required: false
    },
    customerLocked: {
      type: Boolean,
      required: true,
      default: false
    },
    isCoCustomer: {
      type: Boolean,
      required: false,
      default: false
    },
    updatesAuthorized: {
      type: String,
      required: false
    },
    osaRegistrationMsg: {
      type: String,
      required: false,
    },
    debitorennummer: {
      type: Number,
      required: false,
    },
    kundengruppe: {
      type: String,
      required: false,
    },
    siteKundennummer: {
      type: String,
      required: false,
    },
    produktlinien: {
      type: String,
      default: '',    
      required: false,
    }
  },
  data() {
    return {
      prepaidSupportHoursFormatter: 0 as number,
      spentSupportHoursFormatter: 0 as number
    }
  },
  methods: {
    formatterSupportData(data: number) {
      return FormatterHelper.changeDecimalSeparator(
        FormatterHelper.roundNumber2Decimals(data)
      );
    }
  }
})
